<app-split-container>
  <div slot="left">
    <app-login-dialog-image
      *ngIf="!customMessage()"
      [title]="'login.login.infoTitle' | translate"
      [subtitle]="'login.login.infoSubtitle' | translate"
    >
      <app-login-image></app-login-image>
    </app-login-dialog-image>

    <div *ngIf="customMessage()" class="custom-message" [innerHTML]="customMessage() | safe"></div>
  </div>

  <div slot="right">
    <form id="login-form" [formGroup]="form" (submit)="login($event)">
      <formly-form
        [model]="formModel"
        [fields]="formFields[selectedForm]"
        [options]="formOptions"
        [form]="form"
      ></formly-form>

      <re-captcha
        #captcha="reCaptcha"
        *ngIf="loginAttempts() >= maxLoginAttempts()"
        (resolved)="resolvedCaptcha($event)"
        (errored)="errorCaptcha()"
        [errorMode]="'handled'"
      ></re-captcha>
    </form>

    <p *ngIf="externalUrl() !== ''">{{ externalUrlMessage() }}</p>

    <opac-button [disabled]="form.invalid" class="submit-button" actionType="submit" form="login-form">
      {{ 'login.submit' | translate }}
    </opac-button>

    <opac-divider *ngIf="showForgotPassword() || allowSignup()">{{ 'common.or' | translate }}</opac-divider>

    <opac-button *ngIf="isDibam()" class="submit-button login-clave-unica-button" type="tertiary" (click)="navigateToClaveUnica()">
      <opac-icon icon="logo_clave_unica" slot="start"></opac-icon>
      {{ 'login.login.loginWithClaveUnica' | translate }}
    </opac-button>

    <div class="links-container">
      <a
        *ngIf="showForgotPassword()"
        href="#"
        (click)="loadForgotPassword($event)"
        (keydown.enter)="loadForgotPassword($event)"
        (keydown.space)="loadForgotPassword($event)"
      >
        {{ 'login.login.forgotPassword' | translate }}
      </a>

      <span *ngIf="allowSignup()">
        {{ 'login.login.goToSignupText' | translate }}
        <a
          href="#"
          (click)="loadSignup($event)"
          (keydown.enter)="loadSignup($event)"
          (keydown.space)="loadSignup($event)"
        >
          {{ 'login.login.goToSignupLink' | translate }}
        </a>
      </span>
    </div>
  </div>
</app-split-container>
